import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import LoginButtonV2 from '../../../components/Auth/LoginButton'
import { AngleIcon } from '../../../components/Icons'
import { useBrand } from '../../../contexts/BrandContext'
import { useMediaQueryContext } from '../../../contexts/MediaQueryContext'
import { AdminNavigation } from './AdminNavigation'

export function AdminHeader() {
  const { is2lg: isMobile } = useMediaQueryContext()
  const [isVisibleInput, setIsVisibleInput] = useState(false)
  const brand = useBrand()

  useEffect(() => {
    setIsVisibleInput(false)
  }, [isMobile])

  return (
    <div className="tc-mv-header">
      <div className="flex relative tc-mv-header-container">
        {/* bg should be defferend div, othervice it broke bg filters for dropdowns */}
        <div className="absolute bottom-0 duration-300 left-0 opacity-100 right-0 tc-mv-blur top-0 transition-opacity" />
        <div className="flex-grow-0 flex-shrink-0 align-start basis-auto items-center relative tc-mv-header-left">
          <AdminNavigation isMobile={isMobile} />
          {isVisibleInput && isMobile ? (
            <button
              className="flex align-middle border-0 h-10 justify-center rounded-full text-white w-10 font-medium items-center tc-mv-blur tc-mv-logged-user"
              onClick={() => setIsVisibleInput(false)}
            >
              <AngleIcon />
            </button>
          ) : (
            <Link to="/" className="tc-mv-header-logo flex items-center">
              <div className="flex align-middle items-center">
                <img src={brand.logo} className="h-[26px]" />
                <h1 className="text-32px text-white hidden min-950:flex ml-3">
                  Admin
                </h1>
              </div>
            </Link>
          )}
        </div>
        <div className="align-end duration-300 opacity-100 relative tc-mv-header-right transition-opacity">
          <LoginButtonV2 />
        </div>
      </div>
    </div>
  )
}
